import { render } from "./TransfersTable.vue?vue&type=template&id=57bcb3de"
import script from "./TransfersTable.vue?vue&type=script&lang=js"
export * from "./TransfersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__